var _path;
import * as React from "react";
var SvgShareXing = function SvgShareXing(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.14.76a.48.48,0,0,0,0-.54A.5.5,0,0,0,20.76,0H17.13a1.08,1.08,0,0,0-.92.65L8.59,14.29l4.9,9.06a1.06,1.06,0,0,0,1,.65h3.46a.52.52,0,0,0,.47-.22.48.48,0,0,0,0-.54l-4.87-8.95ZM7.1,5.43a1.1,1.1,0,0,0-1-.65H2.64A.5.5,0,0,0,2.17,5a.48.48,0,0,0,0,.54l2.39,4L.83,16a.55.55,0,0,0,0,.53.5.5,0,0,0,.46.25H4.82a1.11,1.11,0,0,0,.94-.67L9.47,9.51Z"
  }));
};
export default SvgShareXing;